import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, mergeMap, switchMap } from "rxjs/operators";
import { RoomRecordingActions } from "../actions";
import {
  RoomRecordingDeleteRequestDTO,
  RoomRecordingSetRequestDTO
} from "../dto";
import { RoomRecordingService } from "../services";

@Injectable()
export class RoomRecordingEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly roomRecordingService: RoomRecordingService
  ) {}

  roomRecordingDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomRecordingActions.roomRecordingDelete),
      switchMap(({ roomRecordingDeleteCmd }) =>
        this.roomRecordingService
          .roomRecordingDelete(
            new RoomRecordingDeleteRequestDTO({
              roomId: roomRecordingDeleteCmd.value.roomId
            })
          )
          .pipe(
            mergeMap(() => [
              RoomRecordingActions.roomRecordingDeleteSuccess({
                roomRecordingDeleteCmd
              })
            ]),
            catchError(() => [
              RoomRecordingActions.roomRecordingDeleteFailure({
                roomRecordingDeleteCmd
              })
            ])
          )
      )
    )
  );

  roomRecordingSet$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoomRecordingActions.roomRecordingSet),
      switchMap(({ roomRecordingSetCmd }) =>
        this.roomRecordingService
          .roomRecordingSet(
            new RoomRecordingSetRequestDTO({
              roomId: roomRecordingSetCmd.value.roomId
            })
          )
          .pipe(
            mergeMap(() => [
              RoomRecordingActions.roomRecordingSetSuccess({
                roomRecordingSetCmd
              })
            ]),
            catchError(() => [
              RoomRecordingActions.roomRecordingSetFailure({
                roomRecordingSetCmd
              })
            ])
          )
      )
    )
  );
}
